import {
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import NFCeConsultaCode from "./NFCe.Consulta.Code";
import NFCeModalPropriedadesView from "./Modal.Propriedades/NFCe.Modal.Propriedades.View";
import { getLabel } from "src/hook/Functions";
import { statusEnvioOptions } from "./NFCe.Consulta.Dto";
import moment from "moment";
import DatePicker from "react-datepicker";
import { NavDatePicker } from "src/componentes/NavDatePicker/NavDatePicker.Component";

const NFCeConsultaView = () => {
  const {
    loading,
    data,
    handleClickPropriedades,
    nfce,
    modalShowPropriedades,
    onCancelModalPropriedades,
    onDeleteModalPropriedades,
    onFetchStatusModalPropriedades,
    filtros,
    handleSelect,
    setDates,
    datePickerTitle,
    handleOnChange,
    onPrintModalPropriedades,
    onDownloadXml,
    handleMenuClickDownloadXML,
  } = NFCeConsultaCode();

  return (
    <>
      <Container>
        <HeadPage headText="NFCe Consulta">
          <Dropdown.Item onClick={handleMenuClickDownloadXML}>
            Download XML
          </Dropdown.Item>
        </HeadPage>
        {!loading ? (
          <>
            <Navbar className="bg-body-tertiary justify-content-between">
              <Container>
                <Navbar.Collapse className="justify-content-end">
                  <Nav className="ms-auto">
                    <Form.Control
                      placeholder="Série"
                      className="bg-body-tertiary"
                      onChange={handleOnChange}
                    ></Form.Control>
                    <NavDropdown
                      onSelect={handleSelect}
                      id="dropdown-codigoStatusEnvio"
                      title={getLabel(
                        statusEnvioOptions,
                        filtros.codigoStatusEnvio,
                        "Status Envio"
                      )}
                    >
                      {statusEnvioOptions.map((option) => (
                        <NavDropdown.Item
                          key={option.value}
                          eventKey={option.value}
                          active={filtros.codigoStatusEnvio === option.value}
                        >
                          {option.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>

                    <DatePicker
                      locale="pt-BR"
                      selected={filtros.dataEmissaoInicial}
                      onChange={setDates}
                      startDate={filtros.dataEmissaoInicial}
                      endDate={filtros.dataEmissaoFinal}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      withPortal
                      isClearable={true}
                      className="nav-datepicker"
                      title={datePickerTitle()}
                      customInput={<NavDatePicker />}
                    />
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>

            <Table responsive hover>
              <thead>
                <tr>
                  <th className="col-2">Número NFCe</th>
                  <th className="col-1">Série</th>
                  <th className="col-4">Status de Envio</th>
                  <th className="d-none d-sm-table-cell col-3">
                    Status Resposta Sefaz
                  </th>
                  <th className="col-2">Data Hora Emissão</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr
                    key={item.nfCeId}
                    onClick={handleClickPropriedades(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="col-2">{item.numeroNF}</td>
                    <td className="col-1">{item.serie}</td>
                    <td className="col-4">
                      {item.codigoStatusEnvio}-{item.descricaoStatusEnvio}
                    </td>
                    <td className="d-none d-sm-table-cell col-3">
                      {item.codigoStatusResposta}-{item.descricaoMotivoResposta}
                    </td>
                    <td className="col-2">
                      {moment(item.emissaoDataHora).format(
                        "DD/MM/YYYY HH:MM:SS"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Container>
      <NFCeModalPropriedadesView
        show={modalShowPropriedades}
        nfce={nfce}
        onCancel={onCancelModalPropriedades}
        onDelete={onDeleteModalPropriedades}
        onPrint={onPrintModalPropriedades}
        onDownloadXml={onDownloadXml}
        onFetchStatus={onFetchStatusModalPropriedades}
      />
    </>
  );
};

export default NFCeConsultaView;
